module.exports = __webpack_public_path__ + "static/footer-joinus-bg-sp-f59888aa0ec45227059c4407ffcc1e3d.jpg";